import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import StudentDashboard from './components/StudentDashboard';
import ProStudentDashboard from './components/ProStudentDashboard';
import CompanyDashboard from './components/CompanyDashboard';
import ScadOfficeDashboard from './components/ScadOfficeDashboard';
import FacultyDashboard from './components/FacultyDashboard';
import { Navigate } from 'react-router-dom';

const Dashboard = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Render the appropriate dashboard based on user role
  switch (user.role) {
    case 'student':
      return <StudentDashboard />;
    case 'proStudent':
      return <ProStudentDashboard />;
    case 'company':
      return <CompanyDashboard />;
    case 'scadOffice':
      return <ScadOfficeDashboard />;
    case 'faculty':
      return <FacultyDashboard />;
    default:
      return <Navigate to="/login" />;
  }
};

export default Dashboard;